import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProductFullPage = lazy(() => import('../views/list/ProductFullPage'));

export function ProductFullPageLazy() {
	return (
		<PageSuspense>
			<ProductFullPage />
		</PageSuspense>
	);
}
